import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { snackbarProgressTimer } from '@orderna/admin-panel/src/utils/snackbar-progress-timer';

@Component({
  selector: 'app-default-snackbar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule],
  templateUrl: './default-snackbar.component.html',
  styleUrl: './default-snackbar.component.css',
})
export class DefaultSnackbarComponent {
  protected progress: number = 100;
  private readonly SNACKBAR_TYPE: string = 'Default';

  constructor(
    public snackBarRef: MatSnackBarRef<DefaultSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { message: string; duration: number }
  ) {}

  ngOnInit(): void {
    const onProgress = (progress: number) => (this.progress = progress);
    const timer = snackbarProgressTimer(
      onProgress,
      this.SNACKBAR_TYPE,
      this.progress,
      this.data.duration
    );

    this.snackBarRef.afterDismissed().subscribe(() => {
      timer();
    });
  }

  dismiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
